(function($) {

    // $(".trigger-search").on("click", function (e) {
    //     e.preventDefault();
    //    $(".wp-search-form").slideToggle({
    //        start: function () {
    //            $(this).css({
    //                display: "flex"
    //            })
    //        }
    //    });
    // });

    $("#close-search-form").on("click", function () {
        $(".wp-search-form").slideToggle();
    });



    $("#search-input").on("keyup", function () {

        $searchValue = $(this).val();

        console.log($searchValue);

        var sendData = {
            action: 'load_search_results',
            s: $searchValue,
        };

        let $container = $("#search-results");

        $.ajax({
            url: ajaxadminurl.ajaxurl,
            type: 'GET',
            data: sendData,
            dataType: 'html',
            cache: false,
            timeout: 10000,
            beforeSend: function () {
                $container.empty();
            },
            success: function(data, textStatus, jqXHR) {
                var htmlData = $.parseHTML(jqXHR.responseText);
                $container.html(htmlData);
            },
        });
    })


})( jQuery );